import { Col, CardHeader, Card, CardBody, Row, Alert, Spinner } from "reactstrap";
import React, { useState, useCallback, lazy, Suspense } from "react";
import Section from "./Section";
import OffcanvasContainer from "./OffcanvasContainer";

const GuideListTab = lazy(() => import('./GuidesListTab'));

const GuidesList = () => {
    const [isRight, setIsRight] = useState(false);
    const [filters, setFilters] = useState({
        dateRange: [],
        establishment: null,
        finalDestination: null
    });

    const toggleRightCanvas = useCallback(() => {
        setIsRight(prevIsRight => !prevIsRight);
    }, []);

    const handleFiltersSubmit = useCallback((newFilters) => {
        setFilters(newFilters);
    }, []);

    return (
        <React.Fragment>
            <Row>
                <Col lg={12}>
                    <Card>
                        <CardHeader className="border-0 pb-0">
                            <Section rightCanvasBtn={toggleRightCanvas} />
                            <OffcanvasContainer 
                                isOpen={isRight} 
                                toggle={toggleRightCanvas} 
                                filters={filters}
                                onSubmit={handleFiltersSubmit}
                            />
                        </CardHeader>
                        <CardBody className="pt-0">
                            <Suspense fallback={
                                (
                                    <Alert color='primary'>
                                        <Spinner size='sm' className='me-2' />
                                        Preparando listado de guías, por favor espere...
                                    </Alert>
                                )
                            }>
                                <GuideListTab filters={filters} />
                            </Suspense>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default React.memo(GuidesList);
